export const DEFAULT_SERVICES = [
  'How you search for lawyers and firms',
  'How we generate search results',
  'How we rank and display profiles',
  'How Advance Search works',
  'How you can make a booking',
]